import { render, staticRenderFns } from "./MaterialView.vue?vue&type=template&id=c6dec560&scoped=true&"
import script from "./MaterialView.vue?vue&type=script&lang=js&"
export * from "./MaterialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dec560",
  null
  
)

export default component.exports